import {Injectable} from '@angular/core';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef} from '@angular/material/snack-bar';

import {CustomSnackbarComponent} from '../components/loader/custom-snackbar/custom-snackbar.component';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private _duration = 25000;

    constructor(private snackBar: MatSnackBar) {
    }

    info = (message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<CustomSnackbarComponent> =>
        this.openSnackbar('info', message, action, config);
    warning = (message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<CustomSnackbarComponent> =>
        this.openSnackbar('warning', message, action, config);
    success = (message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<CustomSnackbarComponent> =>
        this.openSnackbar('success', message, action, config);
    error = (message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<CustomSnackbarComponent> =>
        this.openSnackbar('error', message, action, config);

    private openSnackbar = (
        type = 'info',
        message: string,
        action?: string,
        config?: MatSnackBarConfig
    ): MatSnackBarRef<CustomSnackbarComponent> => {
        this._duration = ['error', 'warning', 'success'].includes(type) ? 5000 : 2500;

        config = config || new MatSnackBarConfig();

        return this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data: {
                message,
                action,
                config,
                type,
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: this._duration,
        });
    };
}
